import React from 'react'

import PropTypes from 'prop-types'

import TextField from '@galo-monitor/web-components/TextField'

const InputFloat = ({ maxLength, readOnly, ...rest }) => (
  <TextField
    { ...rest }
    numberFormatProps={ {
      decimalScale: 2,
      fixedDecimalScale: true,
      thousandSeparator: '.',
      decimalSeparator: ','
    } }
    inputProps={ {
      maxLength,
      readOnly
    } }
    type="tel"
    onFocus={ (event) => event.target.select() }
  />
)

InputFloat.propTypes = {
  maxLength: PropTypes.number,
  readOnly: PropTypes.bool
}

InputFloat.defaultProps = {
  maxLength: 10,
  readOnly: false
}

export default InputFloat
